"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingChecklistTrackerResetT = exports.TrackingChecklistTrackerReset = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const tracker_id_js_1 = require("../../solarxr-protocol/datatypes/tracker-id.js");
/**
 * Trackers that need a reset
 */
class TrackingChecklistTrackerReset {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsTrackingChecklistTrackerReset(bb, obj) {
        return (obj || new TrackingChecklistTrackerReset()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsTrackingChecklistTrackerReset(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new TrackingChecklistTrackerReset()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    trackersId(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new tracker_id_js_1.TrackerId()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    trackersIdLength() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    static startTrackingChecklistTrackerReset(builder) {
        builder.startObject(1);
    }
    static addTrackersId(builder, trackersIdOffset) {
        builder.addFieldOffset(0, trackersIdOffset, 0);
    }
    static createTrackersIdVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startTrackersIdVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static endTrackingChecklistTrackerReset(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createTrackingChecklistTrackerReset(builder, trackersIdOffset) {
        TrackingChecklistTrackerReset.startTrackingChecklistTrackerReset(builder);
        TrackingChecklistTrackerReset.addTrackersId(builder, trackersIdOffset);
        return TrackingChecklistTrackerReset.endTrackingChecklistTrackerReset(builder);
    }
    unpack() {
        return new TrackingChecklistTrackerResetT(this.bb.createObjList(this.trackersId.bind(this), this.trackersIdLength()));
    }
    unpackTo(_o) {
        _o.trackersId = this.bb.createObjList(this.trackersId.bind(this), this.trackersIdLength());
    }
}
exports.TrackingChecklistTrackerReset = TrackingChecklistTrackerReset;
class TrackingChecklistTrackerResetT {
    constructor(trackersId = []) {
        this.trackersId = trackersId;
    }
    pack(builder) {
        const trackersId = TrackingChecklistTrackerReset.createTrackersIdVector(builder, builder.createObjectOffsetList(this.trackersId));
        return TrackingChecklistTrackerReset.createTrackingChecklistTrackerReset(builder, trackersId);
    }
}
exports.TrackingChecklistTrackerResetT = TrackingChecklistTrackerResetT;
